import React from 'react';
import {OrbitComponent} from '../../../../../base-components/orbit-component/orbit-component';
import {PreviewFeatureEvaluationResult} from '../../../../../../services/game-preview-features-selector/preview-features/game-preview-feature.interface';
import {splitArrayToChunks} from '../../../../../../../utils/array-helper';
import {GameFeatureCellComponent} from '../cell/game-feature-cell.component';
import {TableContainerBox} from './boxes/table-container/table-container.box';


export interface GameFeaturesPreviewTableComponentProps {
  features: PreviewFeatureEvaluationResult[]
}

export class GameFeaturesTableComponent extends OrbitComponent<GameFeaturesPreviewTableComponentProps> {

  private _renderGameInfoTableRow(cells: PreviewFeatureEvaluationResult[]) {
    let key = cells.reduce((acc, curr) => curr.title + '_' + acc, '');
    return (
      <tr key={key}>
        {cells.map(cell => (<GameFeatureCellComponent key={cell.title} title={cell.title} type={cell.type} value={cell.value}></GameFeatureCellComponent>))}
      </tr>
    );
  }

  render() {
    if(this.props.features.length === 0) {
      return null;
    }

    let chunks = splitArrayToChunks(this.props.features, 2);

    return (
        <TableContainerBox className='cy-game-preview-features-table' cellSpacing={0}>
            <tbody>
              {chunks.map(chunk => this._renderGameInfoTableRow(chunk))}
            </tbody>
        </TableContainerBox>
    );
  }
}
